import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=62781b04&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=62781b04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62781b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62781b04')) {
      api.createRecord('62781b04', component.options)
    } else {
      api.reload('62781b04', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=62781b04&scoped=true", function () {
      api.rerender('62781b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Avatar.vue"
export default component.exports